module.exports = __webpack_public_path__ + "img/North-Korea.fc5ec159.png";